<template>
    <div ref="container" class="canvas-background">
        <canvas
            ref="canvas"
            aria-hidden="true"
        />
    </div>
</template>

<script>
    export default {
        mounted() {
            this.drawBackground();

            this.resizeObserver = new ResizeObserver(() => {
                this.drawBackground();
            });

            this.resizeObserver.observe(this.$refs.container);

            window.addEventListener('resize', this.drawBackground);
        },

        beforeDestroy() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }

            window.removeEventListener('resize', this.drawBackground);
        },

        methods: {
            drawBackground() {
                const { canvas } = this.$refs;
                const ctx = canvas.getContext('2d');
                const spacing = 24;
                const radius = 64;
                const color = '#9CC8F6';
                const backgroundColor = '#93C3F5';
                const degreesToRotate = 30;

                canvas.width = this.$refs.container.offsetWidth;
                canvas.height = this.$refs.container.offsetHeight;

                ctx.fillStyle = backgroundColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                const diagonal = Math.sqrt(canvas.width ** 2 + canvas.height ** 2);
                const columns = Math.ceil(diagonal / (2 * radius + spacing));
                const rows = columns;

                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate((degreesToRotate * Math.PI) / 180);
                ctx.translate(-diagonal / 2, -diagonal / 2);

                ctx.fillStyle = color;

                for (let i = 0; i <= columns; i += 1) {
                    for (let j = 0; j <= rows; j += 1) {
                        ctx.beginPath();
                        ctx.arc(
                            i * (2 * radius + spacing) + radius,
                            j * (2 * radius + spacing) + radius,
                            radius,
                            0,
                            Math.PI * 2,
                        );
                        ctx.fill();
                    }
                }

                ctx.setTransform(1, 0, 0, 1, 0, 0);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .canvas-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        canvas {
            display: block; /* Remove canvas default margin */
        }
    }
</style>
